import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatTooltipModule } from '@angular/material/tooltip';
import { CreateOrderRoutingModule } from './create-order-routing.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AddDrugModalComponent } from './manual-order/add-drug-modal/add-drug-modal.component';
import { MatFormFieldModule } from '@angular/material/form-field';
import { AddNursingHomeModalComponent } from './manual-order/add-nursing-home-modal/add-nursing-home-modal.component';
import { ConfirmationRxBeforeCreateComponent } from './confirmation-rx-before-create/confirmation-rx-before-create.component';
import { MatOptionModule } from '@angular/material/core';
import { MatDialogModule } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';

@NgModule({
  declarations: [
    AddDrugModalComponent,
    AddNursingHomeModalComponent,
    ConfirmationRxBeforeCreateComponent,
  ],
  imports: [
    CommonModule,
    CreateOrderRoutingModule,
    MatTooltipModule,
    FormsModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatOptionModule,
    MatDialogModule,
    MatButtonModule
  ],
})
export class CreateOrderModule {}
